import {Hooks,Util,XtLocale,Config,Storage,Context} from '@xt/xtbase';
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
const {XtContext,XtAuth} = Context;
const {useTranslation, useIntl, useDocumentWidth} = Hooks;

export const NotifyContext = createContext({});

export const withNotifyContext = (Component) => (props) => {
  const t = useTranslation();
  const [config, setConfig] = useState({
    querys: {
      pushPage: 1,
      pageSize: 20,
      pageIndex: 1,
      lang: XtLocale.intl.locale,
    },
    noticeList: [],
    isFetchList: false,
    autoNotiOpen: false,
    beginCount: true,
    showAutoNotiContent: false,
    manulNotiOpen: false,
    hasNext: true,
  });

  const setQuerys = useCallback((props) => {
    setConfig({
      ...config,
      isFetchList: true,
      querys: {
        ...config.querys,
        ...props,
      },
    });

  }, [config, setConfig]);

  const setContext = useCallback((props) => {
    setConfig({
      ...config,
      ...props,
    });
  }, [config, setConfig]);

  const appendNoticeList = useCallback((list) => {
    if (!list || Object.prototype.toString.call(list) !== '[object Array]') {
      return;
    }
    setConfig({
      ...config,
      hasNext: list.length == config.querys.pageSize,
      isFetchList: false,
      noticeList: [...config.noticeList, ...list],
    });
  }, [config, setConfig]);

  const value = useMemo(() => ({
    t,
    context: config,
    querys: config.querys,
    isSpot: config.querys.pushPage == 1,
    noticeList: config.noticeList,
    setQuerys,
    setContext,
    appendNoticeList,
  }), [t, config, setQuerys, setContext, appendNoticeList]);

  return (
    <NotifyContext.Provider value={value}>
      <Component {...props} />
    </NotifyContext.Provider>
  );
};

export const useNotifyContext = () => {
  const context = useContext(NotifyContext);

  return context;
};
